import { createSelector } from 'reselect'

const userSelector = state => state.user

const userCredentialsSelector = createSelector(
	[userSelector],
	user => user.credentials
)

export default userCredentialsSelector
